import React from 'react'
import thankimg from '../assets/Thanks.png'
const Thanks = () => {
  return (
    <div className='flex justify-center lg:items-center  h-full bg-gradient-to-r from-green-100 via-blue-100 to-green-2000'>
      <div className="w-full lg:flex lg:flex-row flex-col  p-6">
        <div className="lg:w-1/2 w-full flex items-center justify-center">
            <img src={thankimg} alt="" className=' bg-none w-full size-full' />
        </div>
        <div className="lg:w-1/2 w-full flex justify-center  content-center items-center lg:h-auto h-1/2">
            <p className='font-bold lg:text-4xl text-5xl content-center'>Thank You ..Our Executive Call You Soon..</p>
        </div>
      </div>

    </div>
  )
}

export default Thanks
